"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var utils_1 = require("@mui/material/utils");
var SvgBreakerClosed = (0, utils_1.createSvgIcon)(react_1.default.createElement(react_1.default.Fragment, {}, react_1.default.createElement("path", { d: "M16.226 16c-.187-.755-.872-1.645-1.631-2.18a4.507 4.507 0 0 0-5.19 0c-.759.535-1.286 1.186-1.63 2.18H1v-1.995h4.36a7.508 7.508 0 0 1 10.969-2.632c1.266.893 1.99 1.957 2.311 2.632H23V16h-6.774Z" })), 'SvgBreakerClosed');
exports.default = SvgBreakerClosed;
